(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		TitlePanel = include('Lemonade.TitlePanel');

	/**
	 * The logic for the title state
	 * @class Lemonade.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var TitleState = function(options)
	{
		BaseState.call(this, new TitlePanel(), options);

		this.onSelectEn = this.onSelectEn.bind(this);
		this.onSelectEs = this.onSelectEs.bind(this);
		this.onPlay = this.onPlay.bind(this);
	};

	// Extend the base class
	var p = extend(TitleState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		app.state = this;
		app.globalState.currentLocation = "Title Screen";

		// Click either the background or the button
		this.panel.playButtonEn.addEventListener("click", this.onSelectEn);
		this.panel.playButtonEs.addEventListener("click", this.onSelectEs);

		// Select community need
		app.globalState.currentCause = app.getRandomInt(0, app.globalState.causes.length - 1);
	};

	/**
	 * Handler when the play button is clicked
	 * @method  onPlay
	 * @private
	 */
	p.onSelectEn = function()
	{
		app.loadLanguage("en");
		this.onPlay();
	};

	p.onSelectEs = function()
	{
		app.loadLanguage("es");
		this.onPlay();
	};

	p.onPlay = function() {
		GTM_obj.trackGTMEvent('gameLanguageSelect');
		GTM_obj.trackGTMEvent('gamePlay', {'buttonName' : 'PlayButton'});
		
		if (app.globalState.roundsCompleted > 0) {
			this._nextState = "kitchen";
		}
		this.nextState();
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		// Release event listeners
		this.panel.background.cursor = null;
		this.panel.playButtonEn.removeAllEventListeners();
		this.panel.playButtonEs.removeAllEventListeners();
	};

	//Assign to namespace
	namespace("Lemonade").TitleState = TitleState;
}());
